
import React from 'react';
import { useNotifications } from '@/contexts/NotificationsContext';

export const NotificationBadge = () => {
  const { unreadCount } = useNotifications();

  if (unreadCount === 0) {
    return null;
  }

  return (
    <div className="absolute -top-0.5 -right-0.5">
      <div className="bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
        {unreadCount > 9 ? '9+' : unreadCount}
      </div>
    </div>
  );
};
